import * as React from 'react';

function Curling(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 13.651v2.45a4.85 4.85 0 01-1.465 3.464A5.052 5.052 0 0117 21H7a5.053 5.053 0 01-3.536-1.435A4.85 4.85 0 012 16.101v-2.45h20zm-7.257-10.62l.056.011a1.66 1.66 0 011.267 1.115l2.913 4.994a5.016 5.016 0 011.673 1.154c.471.494.833 1.077 1.064 1.713H2.285C2.971 10.116 4.823 8.752 7 8.752h7.907l-1.44-2.469-7.265.045a1.686 1.686 0 01-1.163-.447 1.613 1.613 0 01-.1-2.269 1.68 1.68 0 011.119-.545l.125-.005 8.03-.049a1.7 1.7 0 01.53.017z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Curling;
